import dayjs from "dayjs";

import type {
  CasinoFinanceRow,
  CasinoFinanceSortKey,
} from "./casinoFinanceColumns";

/** Client-side sort for finance table rows (analytics API has no server-side sort params in MVP). */
export function sortCasinoFinanceRows(
  rows: CasinoFinanceRow[],
  field: CasinoFinanceSortKey | null | undefined,
  order: "ascend" | "descend" | null | undefined,
): CasinoFinanceRow[] {
  if (!field || !order) return [...rows];
  const mul = order === "ascend" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const va = a[field];
    const vb = b[field];
    if (field === "date") {
      const ta = a.date ? dayjs(a.date).valueOf() : 0;
      const tb = b.date ? dayjs(b.date).valueOf() : 0;
      if (ta === tb) return 0;
      return ta > tb ? mul : -mul;
    }
    const na = Number(va);
    const nb = Number(vb);
    if (Number.isFinite(na) && Number.isFinite(nb) && na !== nb) {
      return na > nb ? mul : -mul;
    }
    return 0;
  });
}
